import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';
import { toast } from 'react-toastify';

// Thunk to fetch top categories
export const getAllAtributesThunk = createAsyncThunk(
  'attributes/getAllAtributes',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.getAllAtributes(config);

      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);


export const deleteAtributeThunk = createAsyncThunk(
  'atribute/deleteAtribute',
  async (id, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.deleteAtributes(id?.id ?? id, id?.password);
      dispatch(setAtributeRefresh())
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);


export const updateAtribute = createAsyncThunk(
  'atribute/updateAtribute',
  async (atributeData, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.updateAtribute(atributeData);
      dispatch(setAtributeRefresh())
      toast.success(data?.data?.message)
      return status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong')

      return rejectWithValue(error.response.data);
    }
  }
);


export const exportAtributeThunk = createAsyncThunk(
  'atribute/exportAtribute',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.exportAtribute(config);

      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);


export const deletemultipleAtributesThunk = createAsyncThunk(
  'categories/deletemultipleAtributesThunk',
  async (id, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.deletemultipleAttributes(id);
      dispatch(setAtributeRefresh())
      dispatch(setSelectedatributesids([]))
      dispatch(setSelectallattributes(false))
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);


// Slice for categories
const attributesSlice = createSlice({
  name: 'attributes',
  initialState: {
    atributes: [],
    loading: false,
    error: null,
    refresh: false,
    editAtribute: null,
    exportLoading:false,
    page:1,
    exportedData:[],
    selectedIds:[],
    selectAll:false
  },
  reducers: {
    setAtributeRefresh: (state, action) => {
      state.refresh = !state.refresh
    },

    setEditAtribute: (state, action) => {
      state.editAtribute = action.payload;
    },
    setAtributePage:(state,action)=>{
      state.page = action.payload
    },
    setSelectedatributesids:(state,action)=>{
      state.selectedIds = action.payload
    },
    setSelectallattributes:(state,action) =>{
      state.selectAll = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllAtributesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllAtributesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.atributes = action.payload;
      })
      .addCase(getAllAtributesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //delete
      .addCase(deleteAtributeThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAtributeThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteAtributeThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //update
      .addCase(updateAtribute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAtribute.fulfilled, (state, action) => {
        state.loading = false;
        state.editAtribute = null;
      })
      .addCase(updateAtribute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //export atributes
      .addCase(exportAtributeThunk.pending, (state) => {
        state.exportLoading = true;
      })
      .addCase(exportAtributeThunk.fulfilled, (state, action) => {
        state.exportLoading = false;
        state.exportedData = action.payload
      })
      .addCase(exportAtributeThunk.rejected, (state, action) => {
        state.exportLoading = false;
      })
  },
});


export const { setAtributeRefresh, setEditAtribute,setAtributePage,setSelectedatributesids,setSelectallattributes } = attributesSlice.actions
export default attributesSlice.reducer;

